export default __webpack_public_path__ + "static/media/mbl_twitter.2e314a3b.png";